import React, {  useContext } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { servicesSlice } from '../ServicesSlice'

// Gird system
import { Col, Row } from 'react-grid-system'

// Components
import Modal from '../../../components/Modal/Modal'
import { InputField } from '../../../components/FormElements/FormElements'

// Stylesheet
// import './ManageAttributes.css'

import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'
import { editServicePricingSlice, editServicePricingState } from './EditServicePricingSlice'
import { useNotification } from '../../../services/usenotification'
import SettingContext from '../../../services/context/setting-contentxt/setting-context'

import { useAPI } from '../../../services/hoc/useAPI'

export default ({close}:{close:Function}) => {

    // Translation
    const t = useTranslation()
    const {alertError500}=useNotification()
    const {isMobile}  = useContext(SettingContext)
    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { edit_service_pricing: editServicePricingState }) => state.edit_service_pricing)
const ENDPOINTS = useAPI()



    const toggle = () => {
        dispatch(editServicePricingSlice.actions.setIsOpen(!state.isOpen))
        dispatch(editServicePricingSlice.actions.init())
        close()
    }

    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        dispatch(editServicePricingSlice.actions.setIsLoading(true))
        ENDPOINTS.pricing()
        .updateGlassPrices({ prices: state.prices })
        .then((response: any) => {

       
            if (state.glassWorkPrice != null) {
                dispatch(servicesSlice.actions.updateGlassWorkPrice(state.glassWorkPrice))
            }
            dispatch(editServicePricingSlice.actions.setIsLoading(false))
            dispatch(editServicePricingSlice.actions.setIsSuccess(true))
            setTimeout(() => {
                toggle()
                dispatch(editServicePricingSlice.actions.setIsOpen(false))
            }, 1000);
        })
        .  catch((error:any)=>{
            dispatch(editServicePricingSlice.actions.setIsLoading(false))
             dispatch(editServicePricingSlice.actions.setIsSuccess(false))
            alertError500(error)
              setTimeout(() => {
                toggle()
                dispatch(editServicePricingSlice.actions.setIsOpen(false))
            }, 1000);
        })
    }
  
    return (
       <Modal open={state.isOpen} toggle={toggle}>

            {state.isLoading ? <WhiteboxLoader /> : ""}

            {state.isSuccess ? <SuccessMark /> : ""}

            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("pricing")}</h2>

            <form onSubmit={submit} style={{ width: isMobile? "280px" :"450px" }}>

                <div className="attribute">
                    <div className="attribute-fields" style={state.prices.length > 1 ? {} : { padding: 0 }}>
                        <Row>

                            <Col md={12}>
                                <InputField
                                    type="number"
                                    label={t("price")}
                                    value={state.prices[0].price}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        dispatch(editServicePricingSlice.actions.setPriceValue(e.target.value));
                                    }}
                                />
                            </Col>

                        </Row>
                    </div>
                </div>

                <button className="button round bg-gold color-white margin-top-20" style={{ padding: "0 80px", marginBottom: 5 }} >{t("submit")}</button>

            </form>

        </Modal>
    );
}